// A retry is Phoebe's own housekeeping: the step line already names the
// work in progress, so a retry draws nothing.
import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({
    type: z.literal('retry_tool_call'),
    command_id: z.uuid(),
    attempt: z.number().int(),
    not_before: z.iso.datetime({ offset: true }),
    last_error_message: z.string(),
    last_error_type: z.string(),
});

export const retryToolCallDefinitions = {
    retry_tool_call: defineInvisible('retry_tool_call', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const retryToolCallContractFixtures = {
    valid: {
        type: 'retry_tool_call',
        command_id: '01991a6f-4a1f-7f16-8514-f9ffacb89d2c',
        attempt: 2,
        not_before: '2026-08-28T12:00:00Z',
        last_error_message: 'tool-error-sentinel',
        last_error_type: 'tool-error-type-sentinel',
    },
    malformed: {
        type: 'retry_tool_call',
        command_id: 'not-a-uuid',
        attempt: 2,
        not_before: '2026-08-28T12:00:00Z',
        last_error_message: 'tool-error-sentinel',
        last_error_type: 'tool-error-type-sentinel',
    },
} as const;
